module.exports = __webpack_public_path__ + "static/media/CELL_8.3fdab827.png";